import { render, staticRenderFns } from "./ProductsAtributesGroup.vue?vue&type=template&id=41263a1a&scoped=true"
import script from "./ProductsAtributesGroup.vue?vue&type=script&lang=js"
export * from "./ProductsAtributesGroup.vue?vue&type=script&lang=js"
import style0 from "./ProductsAtributesGroup.vue?vue&type=style&index=0&id=41263a1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41263a1a",
  null
  
)

export default component.exports